"use client";

import { HubSpotForm } from "@/components/ui/hubspot-form";
import { HUBSPOT_FORMS, HUBSPOT_PORTAL_ID, HUBSPOT_REGION } from "@/data/hubspot-forms";
import { useTranslations } from "next-intl";

export const HomeHubSpotFormSection = ( {portalId=HUBSPOT_PORTAL_ID, formId=HUBSPOT_FORMS.footer}: { portalId?: string; formId?: string }) => {
  const t = useTranslations("home");

  return (
    <section className="bg-white px-4 section-y dark:bg-surface-dark">
      <div className="surface-card-soft mx-auto max-w-5xl p-6 sm:p-8">
        <div className="text-center">
          <p className="text-xs font-semibold uppercase tracking-label text-brand-red">
            {t("form.eyebrow")}
          </p>
          <h3 className="mt-2 text-2xl sm:text-3xl font-bold text-brand-navy dark:text-white">
            {t("form.title")}
          </h3>
          <p className="mt-2 text-sm sm:text-base text-gray-700 dark:text-gray-300">
            {t("form.subtitle")}
          </p>
        </div>
        <div className="mt-6">
          <HubSpotForm portalId={portalId} formId={formId} region={HUBSPOT_REGION} />
        </div>
      </div>
    </section>
  );
};
